var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["upsell-tag", _vm.classes] }, [
    _c("span", { staticClass: "typographies-paragraph-small-regular" }, [
      _vm._v(_vm._s(_vm.tagLabel))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }